/*
  Calculadora de superficie a cajas.

  El cliente entra los m² del muro —o los deduce de largo y ancho— y le decimos
  cuántas cajas necesita y cuánto cuesta, sumando un porcentaje de merma para
  cortes y roturas. El botón de confirmación escribe el resultado en el selector
  de cantidad de Dawn, así que no hay que trasladar el número a mano.
*/
class MateryCalculadoraM2 extends HTMLElement {
  connectedCallback() {
    this.m2PorCaja = parseFloat(this.dataset.m2PorCaja);
    if (!(this.m2PorCaja > 0)) return;

    this.merma = parseFloat(this.dataset.merma) || 0;
    this.precio = parseInt(this.dataset.precio, 10) || 0;

    this.area = this.querySelector('[data-area]');
    this.largo = this.querySelector('[data-largo]');
    this.ancho = this.querySelector('[data-ancho]');
    this.check = this.querySelector('[data-merma-check]');
    this.cajasEl = this.querySelector('[data-cajas]');
    this.totalEl = this.querySelector('[data-total]');
    this.aplicar = this.querySelector('[data-aplicar]');
    this.abrir = this.querySelector('[data-abrir-medidas]');
    this.panel = this.querySelector('[data-panel-medidas]');

    this.formato = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 2 });
    this.dinero = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: this.dataset.moneda || 'CLP',
      maximumFractionDigits: 0,
    });

    this.area.addEventListener('input', () => this.calcular());
    if (this.check) this.check.addEventListener('change', () => this.calcular());
    this.aplicar.addEventListener('click', () => this.aplicarCantidad());

    if (this.abrir) {
      this.abrir.addEventListener('click', () => {
        const abierto = this.panel.hidden;
        this.panel.hidden = !abierto;
        this.abrir.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        if (abierto) this.largo.focus();
      });
    }

    // Largo y ancho alimentan el campo de superficie, que sigue siendo editable.
    [this.largo, this.ancho].forEach((input) =>
      input.addEventListener('input', () => {
        const sup = this.numero(this.largo.value) * this.numero(this.ancho.value);
        if (sup > 0) this.area.value = this.formato.format(sup);
        this.calcular();
      })
    );
  }

  /* Acepta tanto "12,5" como "12.5" — en Chile se escribe con coma. */
  numero(valor) {
    const n = parseFloat(String(valor).replace(',', '.'));
    return Number.isFinite(n) && n > 0 ? n : 0;
  }

  calcular() {
    const superficie = this.numero(this.area.value);

    if (superficie <= 0) {
      this.cajasEl.textContent = '0';
      if (this.totalEl) this.totalEl.textContent = this.dinero.format(0);
      this.aplicar.hidden = true;
      this.cajas = 0;
      return;
    }

    const aplicaMerma = this.check ? this.check.checked : false;
    const conMerma = aplicaMerma ? superficie * (1 + this.merma / 100) : superficie;
    const cajas = Math.ceil(conMerma / this.m2PorCaja);

    this.cajas = cajas;
    this.cajasEl.textContent = cajas;
    if (this.totalEl) {
      this.totalEl.textContent = this.dinero.format((cajas * this.precio) / 100);
    }
    this.aplicar.hidden = false;
  }

  /*
    Dawn envuelve el input en <quantity-input>, que reacciona al evento change.
    Escribimos el valor y disparamos change para que el componente y las reglas
    de cantidad del producto se enteren.
  */
  aplicarCantidad() {
    if (!this.cajas) return;

    const input = document.getElementById(this.dataset.quantityInputId);
    if (!input) return;

    const max = parseInt(input.dataset.max, 10);
    const cantidad = Number.isFinite(max) ? Math.min(this.cajas, max) : this.cajas;

    input.value = cantidad;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    input.focus({ preventScroll: true });
    input.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

customElements.define('matery-calculadora-m2', MateryCalculadoraM2);
